import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from 'app/entities/ecole/ecole.reducer';
import { getEcoleActiveAnneeScolaire } from 'app/entities/annee-scolaire/annee-scolaire.reducer';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Storage } from 'react-jhipster';
export const AnneeScolaireList = ({ isAuthenticated = false }: { isAuthenticated: boolean }) => {
  const dispatch = useAppDispatch();
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entityActive);
  const anneeScolaireStorage = Storage.session.get('currentAnneeScolaire');
  useEffect(() => {
    dispatch(getEcole(currentEcole.id));
    dispatch(getEcoleActiveAnneeScolaire(currentEcole.id));
  }, []);

  return (
    <>
      {isAuthenticated && (
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            color: '#FFFFFF80',
            padding: '8px 12px',
            fontSize: '0.9rem',
          }}
          data-cy="anneeScolaireMenu"
        >
          <FontAwesomeIcon icon={faCalendar} style={{ marginRight: '10px' }} size="1x" />
          {anneeScolaireStorage ? anneeScolaireStorage.nom : anneeScolaire.nom}
        </span>
      )}
    </>
  );
};

export default AnneeScolaireList;
